import { ProgramCardProps } from "@/utils/types";
// import Link from "next/link";
import { Portable } from "../utility/Portable";
import { sanitize } from "@/utils/sanitize";
import { ImageObject } from "./ImageObject";
import Link from "next/link";

export const ProgramCardWide = async ({
  className,
  componentId,
  copy,
  links,
  logo,
  heading,
  subheading,
  tallLogo,
  themeColor = "tertiary",
}: ProgramCardProps) => {
  const bgClasses: { [key: string]: string } = {
    tertiary: "bg-tertiary",
    primary: "bg-primary",
    primaryDark: "bg-primaryDark",
    secondary: "bg-secondary",
    quaternary: "bg-quaternary",
  };

  const textClasses: { [key: string]: string } = {
    tertiary: "text-primaryDark",
    primary: "text-white",
    primaryDark: "text-white",
    secondary: "text-secondaryDark",
    quaternary: "text-white",
  };

  const buttonClasses: { [key: string]: string } = {
    tertiary: "primary dark",
    primary: "tertiary",
    primaryDark: "secondary alt",
    secondary: "secondary dark",
    quaternary: "tertiary alt",
  };

  const headingClasses: { [key: string]: string } = {
    tertiary: "text-primaryDark",
    primary: "text-primaryDark",
    primaryDark: "text-secondary",
    secondary: "text-secondaryDark",
    quaternary: "text-tertiary",
  };

  return (
    <div
      id={componentId}
      className={`programCard wide rounded-[24px] md:rounded-card  py-10 md:py-[66px] px-10 md:px-[65px] w-full md:max-w-[1000px] flex flex-col md:flex-row ${tallLogo ? "gap-[30px] md:gap-[80px]" : "gap-[30px]"} md:items-center overflow-hidden justify-between ${themeColor ? bgClasses[sanitize(themeColor)] : ""}${className ? ` ${className}` : ""}`}
    >
      <div>
        {tallLogo ? (
          <>
            <ImageObject
              {...tallLogo}
              alt={`${heading} Logo`}
              imageWidth={600}
              className="max-h-[280px] w-[220px] hidden md:block"
            />
            {logo && (
              <ImageObject
                {...logo}
                alt=""
                imageWidth={600}
                className="w-full max-w-[345px] block md:hidden"
              />
            )}
          </>
        ) : (
          <p
            className={`${headingClasses[sanitize(themeColor)]} font-display md:w-[300px] text-[64px] leading-[1]`}
          >
            <span className="md:w-[90%] block">{heading}</span>
            <span className="text-[24px] font-body block font-extrabold mt-4 text-pretty md:w-[75%]">
              {subheading}
            </span>
          </p>
        )}
      </div>
      <div className="md:max-w-[calc(100%-300px)] flex flex-col items-start gap-8">
        <Portable
          content={copy}
          className={`${themeColor ? textClasses[sanitize(themeColor)] : ""} font-semibold`}
        />
        {links && (
          <div className="flex flex-col sm:flex-row gap-4">
            {links.map((link) => {
              const isExternal = link.link?.startsWith("http");
              return (
                link.link && (
                  <Link
                    key={link._key}
                    href={link.link}
                    target={isExternal ? "_blank" : undefined}
                    rel={isExternal ? "noreferrer noopener" : undefined}
                    className={`button small ${buttonClasses[sanitize(themeColor)]}`}
                  >
                    {link.copy}
                  </Link>
                )
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
